<template>
  <div class="costPreview">
    <custom-table :tableData="drugItems" :column="drugTable" border>
      <template slot="processFlag" slot-scope="{row}">
        <span v-if="row.processFlag == '1'">{{ row.isYlcp === '1' ? row.process.processPrice * row.doseNum : row.process.processPrice }}</span>
        <span v-else>0.00</span>
      </template>
    </custom-table>
    <custom-table class="mt9" :tableData="chineseMedicineItems" :column="chineseMedicineTable" border>
      <template slot="itemNum" slot-scope="{row}">
        {{ row.itemNum }}{{ row.itemUnit }}
      </template>
      <template slot="total" slot-scope="{row}">
        {{ $bigNumber(row.itemNum, '*', row.price, 2) }}
      </template>
    </custom-table>
    <custom-table class="mt9" :tableData="physioItems" :column="phyTable" border>
      <template slot="itemNum" slot-scope="{row}">
        {{ row.itemNum }}
      </template>
      <template slot="total" slot-scope="{row}">
        {{ $bigNumber(row.itemNum, '*', row.price) }}
      </template>
    </custom-table>
    <custom-table class="mt9" :tableData="actItems" :column="actTable" border></custom-table>
    <custom-table class="mt9" :tableData="otherItems.items" :column="otherTable" border>
      <template slot="itemNum" slot-scope="{row}">
        {{ row.itemNum }}{{ row.itemUnit }}
      </template>
      <template slot="total" slot-scope="{row}">
        {{ $bigNumber(row.itemNum, '*', row.price) }}
      </template>
    </custom-table>
    <div class="mt9 textRight">
      <span class="size14 color1F23">金额：{{ computeTotalPrice(drugItem, physioItem, chineseMedicineItem,otherItem, actList) }}</span><span
        v-if="registerPrice" class="size13 color6671">（含补录挂号费{{ registerPrice }}）</span>
      <custom-button type="primary" class="ml16" @click="cancel">关闭</custom-button>
    </div>
  </div>
</template>
  
<script>

import CustomTable from '@/components/CustomTable.vue'
import { Common } from '../data/index.js'
export default {
  // 定义引入的组件
  components: { CustomTable },
  props: {
    drugItem: Array,
    comboItem: Array,
    chineseMedicineItem: Array,
    physioItem: Array,
    registerPrice: String | Number,
    otherItem: Object,
    actList: Array,
  },
  data() {
    return {
      drugItems: [],
      physioItems: [],
      otherItems: {},
      actItems: [],
      drugTable: [
        { prop: 'name', label: '中药处方', align: 'left' },
        { prop: 'doseNum', label: '数量', align: 'left' },
        { prop: 'allPrice', label: '金额', align: 'left' },
        { prop: '', label: '加工费', align: 'left', slotName: 'processFlag' },
      ],
      chineseMedicineTable: [
        { prop: 'itemName', label: '中成药处方', align: 'left', width: '300' },
        { prop: 'price', label: '单价', align: 'left' },
        { prop: '', label: '数量', align: 'left', slotName: 'itemNum' },
        { prop: '', label: '金额', align: 'left', slotName: 'total' },
      ],
      phyTable: [
        { prop: 'itemName', label: '理疗项目', align: 'left', width: '300' },
        { prop: 'price', label: '单价', align: 'left' },
        { prop: '', label: '数量', align: 'left', slotName: 'itemNum' },
        { prop: '', label: '金额', align: 'left', slotName: 'total' },
      ],
      actTable: [
        { prop: 'actCseName', label: '套餐名称', align: 'left', width: '300' },
        { prop: 'price', label: '单价', align: 'left' },
        { prop: 'actCount', label: '数量', align: 'left' },
        { prop: 'totalPrice', label: '金额', align: 'left' },
      ],
      otherTable: [
        { prop: 'itemName', label: '非处方项目', align: 'left', width: '300' },
        { prop: 'price', label: '单价', align: 'left' },
        { prop: 'itemNum', label: '数量', align: 'left', slotName: 'itemNum' },
        { prop: '', label: '金额', align: 'left', slotName: 'total' },
      ],
    }
  },
  //计算价格
  computed: {
    computeTotalPrice() {
      let that = this
      return function (drug, phy,chineseMedicineItem, other, actList) {
        if (that.registerPrice) {
          return Common.computeTotalPrice(drug, phy,chineseMedicineItem, other, actList, that.registerPrice)
        } else {
          return Common.computeTotalPrice(drug, phy,chineseMedicineItem, other, actList)
        }
      }
    }
  },
  //变量监听
  watch: {
    drugItem: {
      deep: true,
      immediate: true,
      handler(val) {
        this.getTotalPrice()
      }
    },
    physioItem: {
      deep: true,
      immediate: true,
      handler(val) {
        this.getTotalPrice()

      }
    },
    chineseMedicineItem: {
      deep: true,
      immediate: true,
      handler(val) {
        this.getTotalPrice()

      }
    },
    otherItem: {
      deep: true,
      immediate: true,
      handler(val) {
        this.getTotalPrice()
      }
    },
    actList: {
      deep: true,
      immediate: true,
      handler(val) {
        this.getTotalPrice()
      }
    },
    registerPrice: {
      immediate: true,
      handler(val) {
        this.getTotalPrice()
      }
    }
  },
  // 页面初始化
  created() { },
  // 页面DOM加载完成
  mounted() { },
  //离开页面时执行
  destroyed() { },
  // 页面方法
  methods: {
    /**
      * 计算总价
      */
    getTotalPrice() {
      let otherItems = _.cloneDeep(this.otherItem)
      if (!_.isEmpty(otherItems.items)) {
        otherItems.items = otherItems.items.filter(val => val.itemId != '')
        this.otherItems = otherItems
      }

      let physioItems = _.cloneDeep(this.physioItem)
      let phyList = [];
      physioItems.forEach(val => {
        phyList = phyList.concat(val.items)
      })
      phyList = phyList.filter(k => k.itemId != '')
      this.physioItems = phyList

      let chineseMedicineItems = _.cloneDeep(this.chineseMedicineItem)
      let chineseMedicineList = [];
      chineseMedicineItems.forEach(val => {
        chineseMedicineList = chineseMedicineList.concat(val.items)
      })
      chineseMedicineList = chineseMedicineList.filter(k => k.itemId != '')
      this.chineseMedicineItems = chineseMedicineList

      let drugItems = _.cloneDeep(this.drugItem)
      drugItems.forEach((val, index) => {
        let countPrice = 0;
        val.items.forEach(k=>{
          if(k.isOwned=='0'){
            const singlePrice = this.$bigNumber(k.itemNum, '*', k.price, 4);
            const totalPrice = this.$bigNumber(val.doseNum || 1, '*', singlePrice, 4);
            countPrice =  this.$bigNumber(countPrice, '+', totalPrice, 4);
          }
        })
        val.allPrice = this.$bigNumber(countPrice, '*', 1, 2);
        val.name = '中药处方' + (index + 1)
      })
      this.drugItems = drugItems

      let actItems = _.cloneDeep(this.actList)
      actItems.forEach(val => {
        val['price'] = Math.round(val.totalPrice / val.actCount * 100) / 100
      })
      this.actItems = actItems
    },
    cancel() {
      this.$emit('cancel')
    },

  },
}
</script>
<style lang="less" scoped>
/* 费用预览 */
.costPreview {
  padding: 20px 30px;
}

.nodata {
  padding: 20px;
  text-align: center;
}

.preview {
  border: 1px solid #e6e6e6;
  line-height: 30px;
  margin-bottom: 5px;

  span:first-child {
    width: 120px;
    text-indent: 8px;
    display: inline-block;
    margin-right: 10px;
    background-color: #e6e6e6;
  }

  span:nth-child(2) {
    font-size: 20px;

    small {
      font-weight: bold;
    }
  }
}
</style>